// layerConfig.js

export const BASE_SERVICE_URL =
  "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

export const ADMIN_BOUNDARIES_SUBLAYERS = [
  { id: 1, title: "MP State", visible: false },
  { id: 2, title: "MP Division", visible: false },
  { id: 3, title: "MP District", visible: true },
  { id: 94, title: "MP ULB", visible: false },
  { id: 95, title: "MP Ward", visible: false },
];

export const PROPERTY_SUBLAYERS = [
  { id: 14, title: "Property", visible: false },
  { id: 15, title: "Building Footprint", visible: false },
  { id: 16, title: "Builtup Area", visible: false },
  { id: 17, title: "Slum Area", visible: false },
  { id: 39, title: "Industrial Area", visible: false }
];

// Add all remaining GEO_3 ... GEO_21 layers here

export const GROUPS = [
  {
    url: BASE_SERVICE_URL,
    title: "[1] Administrative Boundaries",
    sublayers: ADMIN_BOUNDARIES_SUBLAYERS
  },
  {
    url: BASE_SERVICE_URL,
    title: "[2] Properties",
    sublayers: PROPERTY_SUBLAYERS
  },
  {
    url: BASE_SERVICE_URL,
    title: "[3] Transportation",
    sublayers: [   
    { id: 45, title: "Roads", visible: false },
    { id: 56, title: "Railway", visible: false },
    { id: 59, title: "Railway Station", visible: false },
    { id: 61, title: "Aircraft Road", visible: false },
    { id: 62, title: "Airport", visible: false },
    { id: 63, title: "Helipad", visible: false },
    { id: 64, title: "Busstand", visible: false },

    ]
  },
  {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer",
    title: "[4] Water Bodies",
    sublayers: [
    { id: 69, title: "Rivers", visible: false },
    { id: 70, title: "Drainage or Nala", visible: false },
    { id: 75, title: "Lake/Pond/Reservoir", visible: false },
    ]
  },
{
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer",
    title: "[5] Water Supply Network",
    sublayers: [
      { id: 1, title: "WTP", visible: false },
    { id: 2, title: "Intake Well", visible: false },
    { id: 3, title: "OHT", visible: false },
    { id: 4, title: "Junction", visible: false },
    { id: 5, title: "RWPM", visible: false },
    { id: 6, title: "CWPM", visible: false },
    { id: 7, title: "Distribution Line", visible: false },
    ]
  },


  {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer",
    title: "[6] Sewerage Network",
    sublayers: [   
    { id: 1, title: "STP", visible: false },
    { id: 2, title: "MPS", visible: false },
    { id: 3, title: "IPS", visible: false },
    { id: 4, title: "Manhole", visible: false },
    { id: 5, title: "Sewer Line", visible: false },
    ]
  },
{
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/stormwater_project_data/MapServer",
    title: "[7] Storm Water Network",
    sublayers: [     
       { id: 1, title: "Storm Water Drainage Line", visible: false },  
    ]
  },

  {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/amrut_scheme/MapServer",
    title: "[8] AMRUT 2.0 ",
    sublayers: [     
    { id: 1, title: "Green Space Development", visible: false },
    { id: 2, title: "Waterbody Rejuvenation", visible: false },
  
    ]
  },

 {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/master_plan/MapServer",
    title: "[9] Master Plan",
    sublayers: [   
    { id: 1, title: "Planning Area", visible: false },
    { id: 2, title: "Master Plan Village Boundary", visible: false },
    { id: 3, title: "Master Plan", visible: false },
    ]
  },

 {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sampda_guideline/MapServer",
    title: "[10] Sampda Guideline ",
    sublayers: [   
    { id: 1, title: "Sampda Guideline 2025_26", visible: false },
    ]
  },


{
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/monuments_site_data/MapServer",
    title: "[11] Archaeological  Site",
    sublayers: [
      { id: 1, title: "Monument Site", visible: false },
      { id: 2, title: "Monument Area", visible: false },
      { id: 3, title: "Protected Zone (0-100 M)", visible: false },
      { id: 4, title: "Regulated Zone (100-300 M)", visible: false }
    ]
  },

  {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/aai_cczm_grid/MapServer",
    title: "[12] CCZM of AAI",
    sublayers: [
      { id: 1, title: "AAI CCZM Grid", visible: false }
    ]
  },

  
   {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/mp_housing_board_colony/MapServer",
    title: "[13] Housing Board",
    sublayers: [
      { id: 1, title: "Housing Board", visible: false }
    ]
  },

  {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/development_autorities_colony/MapServer",
    title: "[14] Development Authorities",
    sublayers: [
      { id: 1, title: "Development Authorities", visible: false }
    ]
  },

    // GEO_7
  
 {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/govt_assets_mis/MapServer",
    title: "[15] Government Assets ",
    sublayers: [     
    { id: 2, title: "Central Govt Assets", visible: false },
    { id: 3, title: "State Govt Assets",   visible: false },
    { id: 4, title: "Municipal Govt Assets", visible: false}
    ]
  },
   {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sbm_data/MapServerr",
    
    title: "[16] SBM ",
    sublayers: [     
    { id: 1, title: "All Processing Plant", visible: false },
    { id: 11, title: "Bio Methanation", visible: false },
    { id: 12, title: "C&D Waste Processing Facility", visible: false },
    { id: 13, title: "Faecal Sludge Treatment Plant (FSTP)", visible: false },
    { id: 14, title: "Material Recovery Facility (MRF)", visible: false },
    { id: 15, title: "STP", visible: false },
    { id: 16, title: "Waste To Compost", visible: false },
    { id: 17, title: "Waste To Energy", visible: false },
    { id: 2, title: "Dump Site", visible: false },
    { id: 3, title: "Landfill", visible: false }
    ]
  },

{
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/mp_lulc_change/MapServer",
    title: "[17] MP Landus",
    sublayers: [     
       { id: 6, title: "Landuse 2022", visible: false },
       { id: 8, title: "Landuse 2024", visible: false },  
  
    ]
  },

  {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/land_suitability/MapServer",
    title: "[18] LandSuitability ",
    sublayers: [     
           { id: 2, title: "For Conservation", visible: false },
           { id: 3, title: "For Plantation", visible: false },
    ]
  },

{
    // https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer",
    title: "[19] Green Spaces",
    sublayers: [     
    { id: 30, title: "Agricultural Area", visible: false },
    { id: 32, title: "Forest", visible: false },
    { id: 33, title: "Vacant Lands", visible: false },
    { id: 34, title: "Waste Lands", visible: false },
    { id: 36, title: "Open Land", visible: false },
    { id: 38, title: "Playground", visible: false },
    { id: 41, title: "Plantation", visible: false },
    { id: 42, title: "Orchyard", visible: false },
    { id: 43, title: "Park", visible: false },
    ]
  },

  

];